import {field} from "../../../stem-core/state/StoreField.js";
import {type StemDate} from "../../../stem-core/time/Date";
import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {TaskStatus} from "../misc/GenericEnums.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {Merchant} from "../MerchantStore";


@globalStore
export class MerchantRecurringTask extends BaseStore("MerchantRecurringTask") {
    @field("Merchant") merchant: Merchant;
    @field(Object) publicConfig: any;
    @field(Number) sleepMinutes: number;
    @field(Boolean) isActive: boolean;
    @field(String) provider: string;
    @field(String) type: string;
    @field(Date) nextScheduled: StemDate;
    @field(TaskStatus) status: TaskStatus;
    @field(Object) statusDetails: any;
    @field(Date) enqueuedAt: StemDate;
    @field(Date) startedAt: StemDate;
    @field(Date) updatedAt: StemDate;
    @field(Date) finishedAt: StemDate;
    @field(String) output: string;
}

export function apiMerchantRestartTask(task: MerchantRecurringTask): Promise<any> {
    return apiClient.post("/merchant/restart_custom_task", {
        taskId: task.id,
    });
}
